import { render, staticRenderFns } from "./ProbationPop.vue?vue&type=template&id=207637c3&"
import script from "./ProbationPop.vue?vue&type=script&lang=ts&"
export * from "./ProbationPop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProbationPop.vue"
export default component.exports